/** The recharging station opened on its Subscription tab, where plans are bought (spec digiscan-web 2026-10-26 §8). */
export const SUBSCRIPTION_TAB_HREF = '/account?station=subscription'
